import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_SE.json';
import exercises from './PILATES_EXERCISES_SE.json';
import recipes from './PILATES_RECIPES_SE.json';

export const PILATES_DATA_SE: ServiceData = {
  articles,
  exercises,
  recipes,
};
